import { useNavigate } from "react-router-dom";
import { AdminHeader } from "./AdminHeader";
import { PageHelmet } from "@/components/PageHelmet/PageHelmet";

export interface AdminDetailsPageProps {
    pageTitle: string;
    listHref: string;
    children: React.ReactNode;
    onSave: () => void;
    onDelete?: () => Promise<void>;
    showDelete?: boolean;
}

export const AdminDetailsPage = ({
    pageTitle,
    listHref,
    children,
    onSave,
    onDelete,
    showDelete = false,
}: AdminDetailsPageProps) => {
    const navigate = useNavigate();

    return (
        <>
            <PageHelmet
                title="Admin"
                prefix={pageTitle}
                robotsOverride="noindex, nofollow"
            />

            <div className="bg-admin-card min-h-screen">
                <AdminHeader
                    title={pageTitle}
                    onBack={() => navigate(listHref)}
                    onDelete={onDelete}
                    showDelete={showDelete}
                    onSave={onSave}
                />

                <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-4">
                    {children}
                </div>
            </div>
        </>
    );
};
